import script from "./jijia-refund-popup.vue?vue&type=script&lang=ts&setup=true"
export * from "./jijia-refund-popup.vue?vue&type=script&lang=ts&setup=true"

import "./jijia-refund-popup.vue?vue&type=style&index=0&id=b836cc9a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b836cc9a"]])

export default __exports__